export default __webpack_public_path__ + "static/media/awl.ad139d02.png";